import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { ICompaniaModel } from 'src/app/models/interfaces/compania/ICompaniaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-configuracion-compania-editar',
  templateUrl: './configuracion-compania-editar.component.html',
  styleUrls: ['./configuracion-compania-editar.component.css']
})
export class ConfiguracionCompaniaEditarComponent implements OnInit {
  id: number = 0;
  model: ICompaniaModel = new CompaniaModel();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companiaService: CompaniaService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { 
    
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.companiaService.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.companiaService.update(this.model).subscribe((data) => {
            this.alertDialogService.open("La compañía fue actualizada");
            this.router.navigate(['/configuracion', 'companias']);  
          });
        }
      });
    }
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
